<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Bình luận</h2>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select" @change="changedCommentsStatus">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="filter.course_id" filterable clearable placeholder="Chọn khóa học" class="input-select" @change="changedCommentsCourse">
            <el-option
              v-for="item in lists.listCourses"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="filter.lesson_id" filterable clearable placeholder="Chọn bài học" class="input-select" @change="changedCommentsLesson">
            <el-option
              v-for="item in lists.listLessons"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="1">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="1">
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới bình luận <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> bình luận
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            width="200"
            label="Học viên">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="courses-info__item">
                  <span>
                    {{ scope.row.user.data.name }}
                  </span>
                </div>

                <div class="courses-info__item">
                  <span>
                    {{ scope.row.user.data.email }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="350"
            label="Khóa học / Bài học">
            <template slot-scope="scope">
              <div class="courses-info">
                <div class="courses-info__item">
                  <span style="color: green">
                    {{ scope.row.course.data.name }}
                  </span>
                </div>
                <div class="courses-info__item">
                  <span>
                    Bài học: {{ scope.row.lesson.data.name }}
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="content"
            label="Bình luận">
            <template slot-scope="scope">
              <div class="courses-info" v-html=scope.row.content>

              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Courses',
  metaInfo () {
    return {
      title: 'Bình luận'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      filter: {
        q: '',
        status: '',
        course_id: '',
        lesson_id: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: 'course,lesson,comment,user'
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Thời gian',
          groupFiled: [
            { label: 'created_at:-1', text: 'Tăng dần' },
            { label: 'created_at:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listCourses: [
          {key: 0, value: 'Chọn khóa học'}
        ],
        listLessons: [

        ]
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchListCourse()
    this.fetchDatabaseModel()
  },
  computed: {
    ...mapGetters('comments', ['getSearchCommentsStatus', 'getSearchCommentsCourse', 'getSearchCommentsLesson'])
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    ...mapActions('comments', ['changeSearchCommentsStatus',
      'changeSearchCommentsCourse',
      'changeSearchCommentsLesson']),
    changedCommentsStatus (payload) {
      this.changeSearchCommentsStatus(payload)
    },
    changedCommentsCourse (payload) {
      this.changeSearchCommentsCourse(payload)
    },
    changedCommentsLesson (payload) {
      this.changeSearchCommentsLesson(payload)
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'comments-index', text: 'Bình luận' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Fetch dữ liệu về lĩnh vực danh sách khóa học
    fetchListCourse () {
      axios.get('courses', {params: {'status': 1, 'limit': 25}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCourses = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực danh sách bài học
    fetchListLesson () {
      axios.get('lessons', {params: {'status': 1, 'limit': -1, 'course_id': this.filter.course_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLessons = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true

      this.filter.status = this.getSearchCommentsStatus
      this.filter.course_id = this.getSearchCommentsCourse
      this.filter.lesson_id = this.getSearchCommentsLesson

      axios.get('comments', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      this.$router.push({name: 'comments-show', params: {course_id: model.id}})
    },
    updateModel (model) {
      this.$router.push({name: 'comments-update', params: {course_id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('comments/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa bình luận: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('comments/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    confirmGiftPotatoForCommentGood (model) {
      this.$confirm('Xác nhận tặng 10 khoai cho comment này', 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.giftPotatoForComment(model)
      }).catch(() => {

      })
    },
    giftPotatoForComment (model) {
      let dataGiftPotatoForComment = {
        'comment_id': model.id
      }
      axios.post('payments/gift-potato-for-comment-good', dataGiftPotatoForComment).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Tặng khoai thành công ghi thành công',
              type: 'success'
            })
            this.$router.push({name: 'payments-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.course_id': function () {
      this.fetchListLesson()
      this.filter.lesson_id = ''
      this.fetchDatabaseModel()
    },
    'filter.lesson_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}
.courses-info__item {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/comments/Index.vue